import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ErcService } from 'ng2-app/services/erc/erc.service';
import { Injectable } from '@angular/core';
import { ClearErcLinkedBusinessesStore, GetErcLinkedBusinesses } from './erc-linked-business.actions';
import { LinkedBusiness } from 'app/models/dto/linked-business.model';

export class ErcLinkedBusiness {
  affiliatedBusinesses: LinkedBusiness[];
  relatedBusinesses: LinkedBusiness[];
}

@State<ErcLinkedBusiness>({
  name: 'ercLinkedBusiness',
  defaults: {
    affiliatedBusinesses: [],
    relatedBusinesses: [],
  }
})

@Injectable()

export class ErcLinkedBusinessState {

  @Selector()
  static affiliatedBusinesses(state: ErcLinkedBusiness) {
    return state.affiliatedBusinesses;
  }
  @Selector()
  static relatedBusinesses(state: ErcLinkedBusiness) {
    return state.relatedBusinesses;
  }

  constructor(private ercService: ErcService) {}

  @Action(GetErcLinkedBusinesses)
  getErcLinkedBusinesses({patchState}: StateContext<ErcLinkedBusiness>, {borrowerId}: GetErcLinkedBusinesses) {
    return this.ercService.getErcLinkedBusinesses(borrowerId).pipe(
      catchError(() => of()),
      map(data => {
        const affiliates = data[0].affiliatedBorrowers.map(borrower => {
          if (!borrower.ercApplicationStatus.includes('incomplete', 'complete', 'inProgress')) {
            borrower.ercApplicationStatus = 'inProgress';
          }
          return borrower;
        });
        patchState({
          affiliatedBusinesses: affiliates,
          relatedBusinesses: data[0].relatedBorrowers
        });
      }));
  }

  @Action(ClearErcLinkedBusinessesStore)
  clearErcLinkedBusinessesStore({ patchState }: StateContext<ErcLinkedBusiness>, {}: ClearErcLinkedBusinessesStore) {
    patchState({ 
      affiliatedBusinesses: [],
      relatedBusinesses: []
    });
  }
}
